import React from "react";
import styles from "./studentWorld.module.scss";
import studentSupportBannerOne from "../../assets/images/studentSupportBannerOne.jpg";
import studentSupportBannerTwo from "../../assets/images/studentSupportBannerTwo.jpg";
import AptechAimsCard from "../CustomComponent/AptechAimsCard.tsx";

import financialAssistance from "../../assets/images/financialAssistance.jpg";
import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";

interface DataItemWorkForce {
  src: string;
  text: string;
  bold: string;
}
const workforce: DataItemWorkForce[] = [
  {
    src: "decision",
    text: "Select a program of their choice",
    bold: "STEP:1",
  },
  {
    src: "location",
    text: "Locate and visit their nearest Aptech centre",
    bold: "STEP:2",
  },
  {
    src: "employeeImprovement",
    text: "Meet a career counsellor to understand loan application process",
    bold: "STEP:3",
  },
  {
    src: "paperIcon",
    text: "Complete necessary paperwork ",
    bold: "STEP:4",
  },
  {
    src: "documentIcon",
    text: "Provide required documents for loan application process. ",
    bold: "STEP:5",
  },
  {
    src: "nomination",
    text: "NBFC will process the application and notify the student upon approval",
    bold: "STEP:6",
  },
  {
    src: "emailProcessIcon",
    text: "Once the loan is approved, students can start with enrolment process",
    bold: "STEP:7",
  },
];

const Studentsupport: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Student World", link: "/students-world" },
    { title: "Scholarship & Financial Aid", link: "" },
  ];

  return (
    <div id="Studentsupport" className={styles.studentsupport}>
      <BreadCrumb menu={breadcrumb} />

      <div className="container">
        <BannerOne />
        <BannerTwo />
        <EducationBenefitSection />
        <StudentLoanSection />
      </div>
    </div>
  );
};
const BannerOne = () => {
  const content = [
    "At Aptech, we believe that quality education should be accessible by all.",
    "Aptech offers financial aid to deserving students by providing them financial assistance. It ensures that nothing stops the students from pursuing their goals.",
  ];
  return (
    <div className={`${styles.sectionMainDivOne} section`}>
      <div className="row mt-5">
        <div className="col-12">
          <ImageTextSection
            imageSrc={studentSupportBannerOne}
            imageAlt="Student work Image"
            content={content}
            heading="Empower Your Future with Scholarship Support at Aptech"
            reverse={true}
          />
        </div>
      </div>
    </div>
  );
};
const BannerTwo = () => {
  const contentBannerTwo = [
    `To be eligible for financial aid,`,
    `<strong>1. Applicants must meet academic performance standards</strong>`,
    `<strong>2. Applicants must demonstrate their financial need </strong>`,
    `Speaking with career counsellors provides students with exact guidance on accessing Aptech’s financial support options for their chosen courses!`,
  ];
  return (
    <div className="section">
      <div className="row">
        <div className={`${styles.sectionMainDiv} col-12`}>
          <ImageTextSection
            imageSrc={studentSupportBannerTwo}
            imageAlt="Student work Image"
            content={contentBannerTwo}
            isMobileReverse={true}
          />
        </div>
      </div>
    </div>
  );
};
const EducationBenefitSection = () => {
  return (
    <div className="section">
      <div className="row">
        <div className="col-12">
          <div className="position-relative">
            <img
              src={financialAssistance}
              alt="AptechImage"
              className={`${styles.educationImg} img-fluid`}
            />
            <div
              className={`d-flex justify-content-end ${styles.EducationsBenefitsOuterDiv}`}
            >
              <div className={styles.EducationsBenefitsInnerDiv}>
                <p className="heading">
                  Benefits of availing education loan from NBFCs: 
                </p>
                <p className="para">
                  <strong>
                    <ul className={styles.benefitslist}>
                      <li>Streamlined and speedy loan approval processes</li>
                      <li>
                        Financial solutions catering to diverse student profiles
                      </li>
                      <li>Competitive interest rates</li>
                      <li>Low-cost EMI</li>
                      <li>Flexible loan repayment options</li>
                    </ul>
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          <p className="para">
            By choosing <strong>Financial Assistance</strong> at Aptech,
            students get benefitted by: 
          </p>
          <p className="para">
            <ul className={`${styles.financialAssistanceList}`}>
              <li>Dedicated support to choose the best financial plan </li>
              <li>
                Real time scholarship eligibility after counselling session 
              </li>
              <li>Installment payment options </li>
              <li>
                Minimal documentation procedure with hassle-free scholarship
                processing 
              </li>
            </ul>
          </p>
        </div>
      </div>
    </div>
  );
};
const StudentLoanSection = () => {
  return (
    <div className="section">
      <div className="row">
        <div className="col-lg-6 col-md-12 col-sm-12">
          <p className="heading">Steps to avail Student Loan </p>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <p className="para">
            To avail loan from one of the NBFCs that Aptech has tied up with,
            interested students must do the following 
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <AptechAimsCard
            title=""
            workforce={workforce}
            contentPadding={false}
          />
        </div>
      </div>
    </div>
  );
};
export default Studentsupport;
